import type Language from "./lang-manager/language.model";

export const languages: Language [] = [
  {name: 'English', code: 'en', flag: 'us.png'},
  {name: 'German', code: 'de', flag: 'de.png'},
  /*{name: 'Italian', code: 'it', flag: 'it.png'},*/
  /*{name: 'Spanish', code: 'es', flag: 'es.png'},
  {name: 'Russian', code: 'ru', flag: 'ru.png'}*/
];
